module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Anmelden","fields":{"email":"E-Mail","password":"Passwort"},"buttons":{"login":"Anmelden"},"alerts":{"error":{"userNotRegistered":"Die eigegebene E-Mail Adresse konnte keinem Account zugeordnet werden","passwordIncorrect":"Das eingegebene Passwort ist falsch"}}}}')
  delete Component.options._Ctor
}
